import { Injectable } from '@angular/core';
import { AppService } from '../../../core/services/app.service';
import { HttpClient } from '@angular/common/http';
import { EventService } from '../../../core/services/event.service';
import { GlobalVariables } from '../../../shared/models/cameralla-global.model';
import { map } from "rxjs/operators";
import * as _ from 'lodash';
import { tap } from "rxjs/internal/operators";
import { CacheService } from "../../../shared/services/cache.service";

@Injectable({
    providedIn: 'root'
})

export class UserService extends EventService {
    static COVER_CHANGE = 'cover_change';
    partnerNavigators = GlobalVariables.partnerNavigators;
    userApi = AppService.getApiUrl() + '/api/customers';
    mobileUserApi = AppService.getApiUrl() + '/api/mobileUsers';
    public uploadCoverAPI = AppService.getApiUrl() + '/api/customers/uploadBanner/';
    photoUrl = AppService.getApiUrl() + '/api/photos';
    lastUpdated = null;
    cacheUserId = null;

    constructor(private http: HttpClient, private cacheService: CacheService) {
        super();
    }

    public static readonly partners = [
        {
            value : "canon",
            id : 2
        },
        {
            value : "explorer",
            id : 1
        },
        {
            value : "mobil",
            id : 3
        },
        {
            value : "hurtigruten",
            id : 4
        },
        {
            value : "kampsport",
            id : 5
        },
        {
            value : "naf",
            id : 6
        }
    ];

    public uploadCover(userId, formData) {
        const url = this.uploadCoverAPI + userId;
        return this.http.post(url, formData);
    }

    getUserInformation(userId, otherUser?, getGalleryDetail = false) {
        const promise1 = otherUser ? this.getUserDetails(userId) : this.getPersonalDetails(userId);
        const promise2 = getGalleryDetail ? this.getGalleryDetails(userId) : Promise.resolve({
            // cover: null,
            totalPhotos: 0,
            ratingAvg: 0,
            totalViews: 0,
        });

        return Promise.all([promise1, promise2]);
    }

    getPersonalDetails(userId) {
        let forceUpdate = false;
        // update info after 10 mins
        if (!this.lastUpdated ||
            (((new Date()).getTime() - this.lastUpdated.getTime()) > 600000) ||
            this.cacheUserId != userId) {
            forceUpdate = true;
            this.lastUpdated = new Date();
            this.cacheUserId = userId;
        }
        
        const request = this.cacheService.cacheRequest('personal-user-detail',
            this.http.get(`${this.userApi}/getUserByWPId/${userId}`).pipe(tap(() => {
                console.log('Force fetch user detail')
            })),  forceUpdate);
        
        return request.getResult().toPromise().then(
            response => {
                response = _.cloneDeep(response);

                if (response['IsSuccess']) {
                    let kartraTags = response['Data'].kartraTags;
                    const permissions = [this.partnerNavigators[0]];
                    response['Data'].isCanon = false;
                    response['Data'].isMobile = false;
                    response['Data'].isHurtigruten = false;
                    response['Data'].isKampsport = false;
                    response['Data'].isNAF = false;

                    if (kartraTags) {
                        kartraTags = JSON.parse(response['Data'].kartraTags);
                        kartraTags = Object.keys(kartraTags).map(function(index) {
                            return kartraTags[index];
                        });

                        response['Data'].kartraTagIds = [];
                        response['Data'].memberships = kartraTags.map(v => v.toLowerCase());

                        this.partnerNavigators.forEach(function (partner) {
                            kartraTags.forEach(function (permission) {
                                    // Apply Hurtigruten partner for English user (Smartphone - HR, English tag)
                                if ((partner.id !== 1 && permission.toLowerCase().includes(partner.value)) || (partner.id === 4 &&
                                    permission.toLowerCase() === 'smartphone - hr')) {
                                    permissions.push(partner);
                                    response['Data'].kartraTagIds.push(partner.id);

                                    if (permission.toLowerCase().includes(UserService.partners[0].value)) {
                                        response['Data'].isCanon = true;
                                    }

                                    if (permission.toLowerCase().includes(UserService.partners[2].value)) {
                                        response['Data'].isMobile = true;
                                    }

                                    if (permission.toLowerCase().includes(UserService.partners[3].value) || permission.toLowerCase() === 'smartphone - hr') {
                                        response['Data'].isHurtigruten = true;
                                    }

                                    if (permission.toLowerCase().includes(UserService.partners[4].value)) {
                                        response['Data'].isKampsport = true;
                                    }

                                    if (permission.toLowerCase().includes(UserService.partners[5].value)) {
                                        response['Data'].isNAF = true;
                                    }
                                }
                            });
                        });
                    }

                    response['Data'].kartraTags = permissions;

                    return Promise.resolve(response['Data']);
                }

                return Promise.resolve(['']);
            },
            error => {
                console.log('ERROR GET PERSONAL DETAIL ' + error);
                console.log(error);
            }
        );
    }

    // Not current user
    getUserDetails(userId) {
        return this.http.get(`${this.userApi}/getUserByWPId/${userId}`).toPromise().then(
            response => {
                response = _.cloneDeep(response);

                if (response['IsSuccess']) {
                    let kartraTags = response['Data'].kartraTags;
                    const permissions = [this.partnerNavigators[0]];
                    response['Data'].isCanon = false;
                    response['Data'].isMobile = false;
                    response['Data'].isHurtigruten = false;
                    response['Data'].isKampsport = false;
                    response['Data'].isNAF = false;

                    if (kartraTags) {
                        kartraTags = JSON.parse(response['Data'].kartraTags);
                        kartraTags = Object.keys(kartraTags).map(function(index) {
                            return kartraTags[index];
                        });

                        response['Data'].kartraTagIds = [];
                        response['Data'].memberships = kartraTags.map(v => v.toLowerCase());

                        this.partnerNavigators.forEach(function (partner) {
                            kartraTags.forEach(function (permission) {
                                // Apply Hurtigruten partner for English user (Smartphone - HR, English tag)
                                if ((partner.id !== 1 && permission.toLowerCase().includes(partner.value)) || (partner.id === 4 &&
                                    permission.toLowerCase() === 'smartphone - hr')) {
                                    permissions.push(partner);
                                    response['Data'].kartraTagIds.push(partner.id);

                                    if (permission.toLowerCase().includes(UserService.partners[0].value)) {
                                        response['Data'].isCanon = true;
                                    }

                                    if (permission.toLowerCase().includes(UserService.partners[2].value)) {
                                        response['Data'].isMobile = true;
                                    }

                                    if (permission.toLowerCase().includes(UserService.partners[3].value) || permission.toLowerCase() === 'smartphone - hr') {
                                        response['Data'].isHurtigruten = true;
                                    }

                                    if (permission.toLowerCase().includes(UserService.partners[4].value)) {
                                        response['Data'].isKampsport = true;
                                    }

                                    if (permission.toLowerCase().includes(UserService.partners[5].value)) {
                                        response['Data'].isNAF = true;
                                    }
                                }
                            });
                        });
                    }

                    response['Data'].kartraTags = permissions;

                    return Promise.resolve(response['Data']);
                }

                return Promise.resolve(['']);
            },
            error => {
                console.log('ERROR GET PERSONAL DETAIL ' + error);
                console.log(error);
            }
        );
    }
    
    getGalleryDetails(userId) {
        const filter = encodeURIComponent(JSON.stringify({
            customerId : +userId
        }));
        const url = `${this.photoUrl}/photoGalleryOverview?criteria=${filter}`;
    
        return this.http.get(url).toPromise().then(
          response => {
              if (response['IsSuccess']) {
                  return Promise.resolve(response['Data']);
              }
      
              return Promise.resolve('');
          },
          error => {
              console.log('getGalleryDetails error  ');
              console.log(error);
          }
        );
        
       // return this.http.get(`${this.userApi}/${userId}/photos?filter[fields][viewsCount]=true&filter[fields][ratings]=true&filter[fields][original]=true&filter[where][wasRelated]=null`)
    }
    
    searchCustomer(keyword, isModerator?, getAll?) {
        let queryObject: any = {};
        if (isModerator) {
            queryObject = {
                where: {
                    is_moderator: 1
                },
                order: 'fullName ASC'
            }
        } else {
             queryObject = {
                where: {
                    and: [
                        {
                            or: [
                                {fullName: {like: `%${keyword}%`}},
                                {email: {like: `%${keyword}%`}},
                            ]
                        },
                        {
                            or: [
                                {is_moderator: 0},
                                {is_moderator: null}
                            ]
                        }
                    ]
                },
                order: 'fullName ASC',
                limit: 10
            }
            
            if (getAll) {
                queryObject.where.and.pop();
            }
        }

        const filter = encodeURIComponent(JSON.stringify(queryObject));
        const url = `${this.userApi}/search_customer?filter=${filter}`;

        return this.http.get(url).pipe(
            map((res: any) => {
                if (res.Data.length > 0) {
                    Array.from(res.Data, (item: any) => {
                        item.tittle = item.fullName + ` (${item.email})`;
                    });
                }
                return res.Data || [];
            })
        );
    }

    getUserAvailable(data) {
        let queryObject: any = {
            where: {
                last_login: {
                    neq: null
                },
                order: 'fullName ASC'
            }
        };

        const filter = encodeURIComponent(JSON.stringify(queryObject));
        const url = `${this.userApi}/search_customer?filter=${filter}`;

        return this.http.get(url).pipe(
            map((res: any) => {
                if (res.Data.length > 0 && data && data.userComments.length > 0) {
                    const date = new Date();
                    const previousTimes = date.setMonth(date.getMonth() - 3);

                    res.Data.filter(item => {
                        // Just send email for user active last 3 months ago.
                        if (item.last_login * 1000 >= previousTimes) {
                            data.userComments.filter(userComment => {
                               if (userComment.id === item.id) {
                                   userComment.isActive = true;
                               }
                            });
                        }
                    } );
                }
                return data || {};
            })
        );
    }

    markModerator(id) {
        return this.http.put(this.userApi + '/markModerator/' + id, {});
    }
    
    getUserBio(id) {
        return this.http.get(this.userApi + '/bio/' + id, {
            params : {
                _preventToast : 'true'
            }
        });
    }
    
    getGoldenRankingList(criteria) {
        let url = '/golden-ranking';
        if (criteria) {
            const params = encodeURIComponent(JSON.stringify(criteria));
            url = url + `?criteria=${params}`;
        }
        
        return this.http.get(this.userApi + url);
    }
    
    createUser(params) {
        return this.http.post(this.mobileUserApi, params);
    }
}
